// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAaa5-oeM-ee4SQChXMKs0XwYbAjVHylWQ",
    authDomain: "medical-e28bc.firebaseapp.com",
    databaseURL: "https://medical-e28bc-default-rtdb.firebaseio.com",
    projectId: "medical-e28bc",
    storageBucket: "medical-e28bc.firebasestorage.app",
    messagingSenderId: "725798511477",
    appId: "1:725798511477:web:e56d62131113cf210d293c",
    measurementId: "G-7BVV65Y8JH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);  // Ensure auth is initialized
export const database = getDatabase(app);
export default app;